<template>
  <v-navigation-drawer
    style="background-color: #1a272e; box-shadow: 0px 0px 0px 1px rgba(0, 0, 0, 0.3); z-index: 200"
    v-model="getDrawer"
    :width="250"
    app
    :temporary="drawerPosition"
  >
    <v-dialog
      v-model="isShowDeleteChDialog"
      width="360"
      content-class="rounded-lg"
      overlay-opacity="0.5"
      overlay-color="#000"
    >
      <v-card class="tapeBackgroundPrimary">
        <v-card-title class="font-weight-bold white--text">{{ $t('deleteChannel') }}</v-card-title>

        <v-card-text class="coloredSubText--text pt-1 pb-2">{{ $t('deleteChannelContent') }}</v-card-text>

        <v-card-actions class="pa-4">
          <v-row no-gutters>
            <v-col cols="6" class="px-2">
              <v-btn block class="white--text text-capitalize" color="#ff575f" @click="deleteCh">
                {{ $t('delete') }}
              </v-btn>
            </v-col>
            <v-col cols="6" class="px-2">
              <v-btn block class="white--text text-capitalize" color="#869399" @click="isShowDeleteChDialog = false">
                {{ $t('cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-menu v-model="isWsSelectorOpened" :key="'Large'" offset-y>
      <template v-slot:activator="{ attrs, on }">
        <v-row
          align="center"
          justify="center"
          class="pt-3 ml-0 pl-0 pr-4 pb-3 btn-sidebar"
          v-bind="attrs"
          v-on="on"
          no-gutters
        >
          <v-col cols="auto" align-self="center" class="text-center">
            <v-avatar
              :color="
                (!selectedWsInfo.wsLogo || selectedWsInfo.wsLogo === null ? selectedWsInfo.wsName : '') | iconBackground
              "
              class="logo"
              rounded
              size="30"
            >
              <span class="white--text text-h6 cent" v-if="!selectedWsInfo.wsLogo">
                {{ selectedWsInfo.wsName | iconFilter }}
              </span>
              <v-img :src="selectedWsInfo.wsLogo" v-else />
            </v-avatar>
          </v-col>
          <v-col cols="8" class="ml-3 ws-name">
            {{ selectedWsInfo.wsName }}
          </v-col>
          <v-spacer />
          <!-- <v-col cols="auto">
            <v-icon>mdi-chevron-down</v-icon>
          </v-col> -->
        </v-row>
      </template>
      <v-list :color="'#31434f'" class="menu-ws" style="width: 250px">
        <template>
          <!-- <v-divider v-if="index !== 0" inset height="10px" color="#3f545b" :key="index" style="margin-right: 20px" /> -->
          <v-list-item v-for="item in userWsList" :key="item.wsId" color="white" @click="selectWs(item)">
            <v-list-item-icon>
              <v-avatar
                :color="(!item.wsLogo || item.wsLogo === null ? item.wsName : '') | iconBackground"
                class="logo"
                rounded
                size="30"
              >
                <span class="white--text text-h6 cent" v-if="!item.wsLogo">
                  {{ item.wsName | iconFilter }}
                </span>
                <v-img :src="item.wsLogo" v-else />
              </v-avatar>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="ws-name">{{ item.wsName }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
        <v-divider color="#96a7af" />
        <v-list-item color="white" class="pl-4 pt-2">
          <button class="btn-workspace" @click="joinOrCreateWorkspace">
            {{ $t('joinOrCreateWorkspace') }}
          </button>
        </v-list-item>
      </v-list>
    </v-menu>
    <!-- <v-btn @click="requestResponse">Request</v-btn> -->
    <v-list flat class="mt-5">
      <!-- <v-hover v-for="(channel, index) in chList[chType]" :key="channel['chId']"> -->
      <!-- <v-list-item
        v-for="channel in chList['inbox']"
        :key="channel['chId']"
        class="btn-sidebar pl-4"
        style="width: 100%"
        :to="{
          name: 'Channel',
          params: {
            wsDomain: selectedWsInfo.wsDomain,
            chId: channel['chId'].replace('CH:', ''),
            selectCh: channel,
          },
        }"
        active-class="active"
      >
        <v-list-item-icon class="d-flex justify-center mr-4">
          <span class="material-icons-round font-weight-light" style="color: #96a7af; font-size: 20px" translate="no">
            inbox
          </span>
        </v-list-item-icon>
        <v-list-item-content class="mr-1 py-0">
          <v-list-item-title :class="mtPermission === 'I' ? 'activeColor' : ''">
            <v-row no-gutters>
              <v-col cols="auto">
                <span class="menu-title" style="position: relative">
                  {{ $t('inbox') }}
                </span>
              </v-col>
              <v-spacer v-if="channel['updateCnt'] > 0" />
              <v-col cols="auto" class="pl-3 mr-6" v-if="channel['updateCnt'] > 0">
                <v-chip color="#ff575f" dark x-small label class="pa-1">
                  {{ channel['updateCnt'] > 999 ? '999+' : channel['updateCnt'] }}
                </v-chip>
              </v-col>
            </v-row>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item> -->
      <v-list-item
        class="btn-sidebar"
        style="width: 100%"
        :to="{ name: 'Assigned', params: { wsDomain: selectedWsInfo.wsDomain } }"
        @click.native.exact="$store.dispatch('setSelectedCh', {})"
        active-class="active"
      >
        <v-list-item-icon class="d-flex mr-1">
          <span class="material-icons-round" style="color: #96a7af; font-size: 18px" translate="no">task</span>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title :class="mtPermission === 'A' ? 'activeColor' : ''">
            <v-row justify="start">
              <v-col cols="8">
                <span class="menu-title" style="position: relative; line-height: 18px">
                  {{ $t('assignedToMe') }}
                </span>
              </v-col>
              <v-col cols="2">
                <v-badge
                  color="#eee"
                  inline
                  :content="assignedInfo['inboxCnt']"
                  :value="assignedInfo['inboxCnt']"
                  class="mt-0 noti-badge"
                  v-if="assignedInfo"
                ></v-badge>
              </v-col>
            </v-row>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-hover v-for="chType in Object.keys(chList)" :key="chType">
        <v-list-group
          sub-group
          v-show="chType !== 'inbox'"
          :value="true"
          no-action
          prepend-icon=""
          disabled
          class="mt-5"
          slot-scope="{ hover: groupHover }"
          active-class="pr-2"
          :ripple="false"
        >
          <template v-slot:activator v-if="chType !== 'add'">
            <v-list-item-content>
              <v-list-item-title class="font-weight-normal" style="font-size: 12px; cursor: default">
                {{ chType === 'workspace' ? $t('teamChannelTitle') : chType.charAt(0).toUpperCase() + chType.slice(1) }}
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-icon class="ma-0 align-self-center">
              <v-btn
                icon
                small
                :disabled="!groupHover"
                :style="`opacity: ${groupHover ? 1 : 0}`"
                @click="addCh(chType)"
                v-if="!isNewCh && (chType === 'private' || isWsManager || isWsOwner)"
              >
                <v-icon size="16">mdi-plus</v-icon>
              </v-btn>
            </v-list-item-icon>
          </template>

          <v-hover v-for="(channel, index) in chList[chType]" :key="channel['chId']">
            <v-list-item
              v-show="channel.chCategory !== 'inbox'"
              class="btn-sidebar pl-10 pr-0"
              active-class="active"
              slot-scope="{ hover: itemHover }"
              :to="
                chRenameTarget === null
                  ? {
                      name: 'Channel',
                      params: {
                        wsDomain: selectedWsInfo['wsDomain'],
                        chId: channel['chId'].replace('CH:', ''),
                        selectCh: chRenameTarget === null ? channel : {},
                      },
                    }
                  : ''
              "
            >
              <v-list-item-content class="mr-0 py-0">
                <v-list-item-title :class="[{ activeColor: mtPermission === channel['chId'] }]">
                  <v-row no-gutters>
                    <v-col cols="auto">
                      <v-text-field
                        dense
                        flat
                        solo
                        hide-details
                        background-color="#162127"
                        dark
                        class="ch-name"
                        v-if="
                          chRenameTarget !== null &&
                          chRenameTarget['chType'] === chType &&
                          chRenameTarget['index'] === index
                        "
                        @click.prevent
                        autofocus
                        v-model="chName"
                        :placeholder="$t('renamePlaceholder')"
                        @keyup.enter="blurRenameCh"
                        @keyup.esc="cancelRenameCh"
                        @blur="saveRenameCh"
                      >
                        <template v-slot:prepend>
                          <!-- <span class="coloredSubText--text">#&nbsp;&nbsp;</span> -->
                          <span
                            class="material-icons-round font-weight-light mr-1"
                            style="color: #96a7af; font-size: 15px; vertical-align: middle"
                            translate="no"
                          >
                            folder
                          </span>
                        </template>
                      </v-text-field>
                      <span class="ch-name" v-else>
                        <span
                          class="material-icons-round font-weight-light mr-1"
                          style="color: #96a7af; font-size: 15px; vertical-align: middle"
                          translate="no"
                        >
                          folder
                        </span>
                        &nbsp;{{ channel['chName'] }}
                      </span>
                    </v-col>
                    <v-spacer v-if="chRenameTarget === null && channel['updateCnt'] > 0" />
                    <v-col cols="auto" class="pl-1" v-if="chRenameTarget === null && channel['updateCnt'] > 0">
                      <v-badge
                        color="#eee"
                        inline
                        :content="channel['updateCnt'] > 999 ? '999+' : channel['updateCnt']"
                        :value="channel['updateCnt'] > 999 ? '999+' : channel['updateCnt']"
                        class="mt-0 noti-badge"
                      ></v-badge>
                      <!-- <v-chip
                        color="#ff464f"
                        light
                        x-small
                        label
                        class="pa-1"
                        style="font-size: 10px; font-weight: 600"
                      >
                        {{ channel['updateCnt'] > 999 ? '999+' : channel['updateCnt'] }}
                      </v-chip> -->
                    </v-col>
                  </v-row>
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-icon class="align-self-center ma-0 ml-1" v-if="chRenameTarget === null">
                <v-menu top close-on-click rounded="lg" dark v-if="chType === 'private' || isWsManager || isWsOwner">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      small
                      :disabled="!itemHover"
                      :style="`opacity: ${
                        (chType === 'private' || isWsManager || isWsOwner) && index !== 0 && itemHover ? 1 : 0
                      }`"
                      v-bind="attrs"
                      v-on="on"
                      @click.prevent
                    >
                      <v-icon size="14">mdi-dots-horizontal</v-icon>
                    </v-btn>
                  </template>

                  <v-list class="px-2 tapeBackgroundSecondary">
                    <v-list-item
                      v-show="index !== 0"
                      class="pl-2 pr-8 font-weight-bold"
                      @click="renameCh(chType, index, channel['chName'])"
                    >
                      <v-list-item-title>{{ $t('rename') }}</v-list-item-title>
                    </v-list-item>
                    <v-divider v-show="index !== 0" />
                    <v-list-item
                      v-show="index !== 0"
                      class="pl-2 pr-8 font-weight-bold"
                      @click="showDeleteCh(chType, index)"
                    >
                      <v-list-item-title>{{ $t('delete') }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-list-item-icon>
            </v-list-item>
          </v-hover>
        </v-list-group>
      </v-hover>
      <button
        v-if="isWsManager || isWsOwner"
        @click="openDialog('Slot')"
        class="btn-add-member"
        width="100%"
        color="white"
      >
        + {{ $t('addMember') }}
      </button>
    </v-list>

    <template v-slot:append>
      <v-list-item
        v-show="!isExtensionInstalled"
        style="width: 100%"
        class="pb-0 pl-8 btn-sidebar mt-3"
        @click="installExtension"
      >
        <v-list-item-icon class="d-flex justify-center" style="margin-right: 16px !important">
          <span class="material-icons-round v-icon" style="font-size: 20px" translate="no">get_app</span>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title style="color: #96a7af">
            <span class="menu-title">{{ 'Install Tape Extension' }}</span>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-row no-gutters class="container-quick mr-15">
        <v-tooltip bottom color="#131b1e">
          <template v-slot:activator="{ on }">
            <v-btn
              class="btn-quick quick-record"
              height="45"
              color="rgb(40, 144, 103)"
              block
              @click="setClipType('record')"
              v-on="on"
            >
              <img
                :src="require('@/assets/img/tape-logo-white.png')"
                alt="tape logo"
                class="mr-4"
                style="width: 25px"
              />
              Quick Record
            </v-btn>
            <v-btn class="btn-quick record" height="45" color="#ff575f" block @click="setClipType('record')" v-on="on">
              <span class="material-icons-round mr-4" style="font-size: 20px">radio_button_checked</span>
              Record
            </v-btn>

            <!-- <v-btn class="mt-2 btn-quick-sub text" block @click="setClipType('text')" v-on="on">Text</v-btn>
            <v-btn class="mt-2 btn-quick-sub upload" block @click="setClipType('upload')" v-on="on">Upload</v-btn>
            <v-btn class="mt-2 btn-quick-sub poll" block @click="setClipType('poll')" v-on="on">Poll</v-btn>
            <v-btn class="mt-2 btn-quick-sub embed" block @click="setClipType('embed')" v-on="on">Embed</v-btn> -->
          </template>
          <span>{{ $t('tooltipQuickRecord') }}</span>
        </v-tooltip>
      </v-row>
      <v-list-item style="width: 100%" class="pb-0 pl-8 mb-5 btn-sidebar" @click="openDialog('Setting')">
        <v-list-item-icon class="d-flex justify-center" style="margin-right: 16px !important">
          <v-icon color="#96a7af" style="font-size: 20px">mdi-cog</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title style="color: #96a7af">
            <span class="menu-title">{{ $t('setting') }}</span>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
    <require-upgrade-dialog
      v-if="upgradeVisible"
      @close="upgradeVisible = false"
      :requireUpgradeVisible.sync="upgradeVisible"
      :branch.sync="type"
    ></require-upgrade-dialog>
  </v-navigation-drawer>
</template>

<script>
import value from '@/common/value'
import { mapGetters } from 'vuex'
import Toast from '@/views/meeting/component/Toast'
import { delChannel, setChannel } from '@/services/channelApi'
import RequireUpgradeDialog from '@/views/modal/RequireUpgradeDialog'
import { checkIsExtensionInstalled, installExtension } from '@/services/extension.js'

export default {
  components: {
    RequireUpgradeDialog,
  },
  name: 'SideBar',
  created() {
    this.getDrawer = this.$route.meta.sidebar
    this.drawerPosition = this.$route.meta.sidebarPosition
  },
  props: {
    drawer: Boolean,
  },
  data() {
    return {
      type: '',
      upgradeVisible: false,
      links: value.navMenuList,
      isWsSelectorOpened: false,
      getDrawer: this.drawer,
      drawerPosition: '',
      chRenameTarget: null,
      chDeleteTarget: null,
      isShowDeleteChDialog: false,
      isNewCh: false,

      isExtensionInstalled: false,
    }
  },
  mounted() {
    let isActive = false
    const container = document.getElementsByClassName('container-quick')

    this.checkIsExtensionInstalled()

    for (let i = 0; i < container.length; i++) {
      container[i].addEventListener('mouseover', addActive, false)
      container[i].addEventListener('mouseleave', removeActive, false)
    }

    function addActive() {
      if (!isActive) {
        for (let i = 0; i < container.length; i++) {
          container[i].classList.add('isActive')
        }
        isActive = !isActive
      }
    }

    function removeActive() {
      if (isActive) {
        for (let i = 0; i < container.length; i++) {
          container[i].classList.remove('isActive')
        }
        isActive = !isActive
      }
    }
  },
  computed: {
    ...mapGetters([
      'userInfo',
      'currentMt',
      'userWsList',
      'selectedWsInfo',
      'chList',
      'assignedInfo',
      'selectedCh',
      'isWsOwner',
      'isWsManager',
      'wsClipCnt',
    ]),
    computedWsClipCnt() {
      return this.wsClipCnt ?? {}
    },
    checkAvailableClip() {
      let isAvailableClip = true
      if (
        this.userInfo &&
        (!this.computedWsClipCnt['planType'] || this.computedWsClipCnt['planType'] !== 'Plus') &&
        this.computedWsClipCnt['wsClipDuration'] >= this.computedWsClipCnt['freePlanWsClipDurationLimit']
      ) {
        isAvailableClip = false
      }
      return isAvailableClip
    },
    mtPermission() {
      if (this.selectedCh['chCategory'] === 'inbox') {
        return 'I'
      }
      if (this.$route.name.indexOf('Assigned') > -1) {
        return 'A'
      }
      if (this.selectedCh) return this.selectedCh['chId']
      return ''
    },
  },
  watch: {
    isWsSelectorOpened(val) {
      if (val) this.getUserWsList()
    },
    getDrawer(val) {
      this.getDrawer = val
      this.$emit('setDrawer', val)
      this.$store.dispatch('setDrawer', val)
    },
  },
  methods: {
    checkIsExtensionInstalled() {
      this.isExtensionInstalled = checkIsExtensionInstalled()
    },

    installExtension() {
      installExtension()
    },

    setClipType(type) {
      this.type = type
      if (!this.checkAvailableClip) {
        this.upgradeVisible = true
        return
      } else {
        // Quick Record 인지 여부
        this.$store.dispatch('setIsQuickRecord', true)
        this.$store.dispatch('setIsRequestVideoType', type)
      }
    },
    joinOrCreateWorkspace() {
      this.$router.push({ name: 'Workspace', params: { isJoinOrCreate: true } }).catch(() => {})
    },
    changeWorkspace(workSpace) {
      this.$emit('changeWorkspace', workSpace)
    },
    openDialog(type) {
      this.$emit('openDialog', type)
    },
    async selectWs(ws) {
      try {
        this.$store.dispatch('setIsLoading', true)
        this.$store.dispatch('setIsLoadingProgress', false)
        localStorage.setItem('lastSelectedWsInfo', JSON.stringify(ws))
        await this.$store.dispatch('setSelectedWsInfo', ws)
        location.href = '/' + ws.wsDomain + '/my'
      } catch (err) {
        console.log(err)
      }
    },
    async getUserWsList() {
      try {
        this.$store.dispatch('getUserWsList')
      } catch (err) {
        console.log(err)
      }
    },
    async addCh(chType) {
      this.$store.dispatch('setIsLoading', true)

      try {
        let chTypeInitial
        if (chType === 'private') chTypeInitial = 'P'
        else if (chType === 'workspace') chTypeInitial = 'W'

        // 새 채널 추가 시 임시로 채널 생성
        let tempCh = {
          chId: '',
          chName: '',
          chPermission: chTypeInitial === 'P' ? this.userInfo.userId : 'U',
          chType: chTypeInitial,
          mtId: [],
          wsId: this.selectedWsInfo.wsId,
        }

        let typeChList = this.$store.state.channel.chList[chType]
        typeChList.push(tempCh)
        this.isNewCh = true
        this.renameCh(chType, typeChList.length - 1, typeChList[typeChList.length - 1]['chName'])
      } catch (error) {
        console.log(error)
        // notify(this, 'Error', this.$t('addChannelFailed'), 'error')

        const content = {
          component: Toast,
          props: {
            msg: this.$t('addChannelFailed'),
            // submsg: '',
          },
        }
        this.$toast.error(content)
      } finally {
        this.$store.dispatch('setIsLoading', false)
      }
    },
    async renameCh(chType, index, chName) {
      this.chRenameTarget = {
        chType,
        index,
      }
      this.chName = chName
    },
    checkRenameCh(event) {
      let target = event.target
      let chName = target.value.trim()
      let targetChInfo = this.$store.state.channel.chList[this.chRenameTarget['chType']][this.chRenameTarget['index']]

      if (!this.isNewCh && targetChInfo['chName'] === this.chName) {
        this.cancelRenameCh()
        return false
      }

      if (chName.length === 0) {
        // notify(this, 'Error', this.$t('renameChannelLengthError'), 'error')

        const content = {
          component: Toast,
          props: {
            msg: this.$t('renameChannelLengthError'),
            // submsg: '',
          },
        }
        this.$toast.error(content)
        return false
      }

      let sameCheckTarget = this.chList[`${this.chRenameTarget['chType']}`].slice()
      sameCheckTarget.splice(this.chRenameTarget['index'], 1)

      if (sameCheckTarget.findIndex((ch) => ch['chName'] === chName) > -1) {
        // notify(this, 'Error', this.$t('renameChannelSameError'), 'error')

        const content = {
          component: Toast,
          props: {
            msg: this.$t('renameChannelSameError'),
            // submsg: '',
          },
        }
        this.$toast.error(content)
        return false
      }

      if (this.isNewCh && targetChInfo['chName'] === this.chName) {
        this.cancelRenameCh()
        return false
      }

      return true
    },
    blurRenameCh(event) {
      if (!this.checkRenameCh(event)) return

      event.target.blur()
    },
    cancelRenameCh() {
      // 새 채널 추가 중에 취소할 경우 임시로 생성한 채널 삭제
      if (this.isNewCh) {
        let typeChList = this.$store.state.channel.chList[this.chRenameTarget.chType]
        typeChList.splice(-1, 1)
        this.isNewCh = false
      }
      this.chRenameTarget = null
    },
    async saveRenameCh(event) {
      if (!this.checkRenameCh(event)) return

      this.$store.dispatch('setIsLoading', true)

      try {
        let targetChInfo = this.$store.state.channel.chList[this.chRenameTarget['chType']][this.chRenameTarget['index']]
        let chTypeInitial
        if (this.chRenameTarget['chType'] === 'private') chTypeInitial = 'P'
        else if (this.chRenameTarget['chType'] === 'workspace') chTypeInitial = 'W'
        this.chName = this.chName.trim()

        let result
        if (this.isNewCh) {
          result = await setChannel(this, this.userInfo.userId, this.selectedWsInfo.wsId, chTypeInitial, this.chName)
        } else {
          result = await setChannel(
            this,
            this.userInfo.userId,
            this.selectedWsInfo.wsId,
            chTypeInitial,
            this.chName,
            targetChInfo['chId']
          )
        }

        if (result) {
          // notify(this, 'Success', this.$t(this.isNewCh ? 'addChannelSuccess' : 'renameChannelSuccess'), 'success')

          const content = {
            component: Toast,
            props: {
              msg: this.$t(this.isNewCh ? 'addChannelSuccess' : 'renameChannelSuccess'),
              // submsg: '',
            },
          }
          this.$toast.success(content)
          if (this.isNewCh) {
            let typeChList = this.$store.state.channel.chList[this.chRenameTarget['chType']]
            typeChList.splice(-1, 1, result)
          } else {
            targetChInfo['chName'] = this.chName
          }
          this.isNewCh = false
        } else {
          // notify(this, 'Error', this.$t('renameChannelFailed'), 'error')

          const content = {
            component: Toast,
            props: {
              msg: this.$t('renameChannelFailed'),
              // submsg: '',
            },
          }
          this.$toast.error(content)
        }
      } catch (error) {
        // notify(this, 'Error', this.$t('renameChannelFailed'), 'error')

        const content = {
          component: Toast,
          props: {
            msg: this.$t('renameChannelFailed'),
            // submsg: '',
          },
        }
        this.$toast.error(content)
      } finally {
        this.chRenameTarget = null
        this.$store.dispatch('setIsLoading', false)
      }
    },
    async showDeleteCh(chType, index) {
      this.chDeleteTarget = {
        chType,
        index,
      }
      this.isShowDeleteChDialog = true
    },
    async deleteCh() {
      this.isShowDeleteChDialog = false
      this.$store.dispatch('setIsLoading', true)

      try {
        let channel = this.chList[this.chDeleteTarget['chType']][this.chDeleteTarget['index']]

        let result = await delChannel(this, this.selectedWsInfo.wsId, channel['chId'], channel['chCategory'])
        // 채널이 삭제되었을 시 workspace 의 총 클립 갯수를 새롭게 업데이트 시켜준다.

        this.$store.dispatch('setWsClipCnt', {
          wsDomain: this.$route.params['wsDomain'],
          userId: this.userInfo ? this.userInfo['userId'] : null,
        })

        if (result) {
          this.chDeleteTarget = null

          // 만약 현재 위치의 채널과 삭제 채널이 일치하면, 해당 타입의 기본 채널로 강제 이동
          if (channel['chId'].replace('CH:', '') === this.selectedCh['chId'].replace('CH:', '')) {
            let redirectChannel
            if (this.selectedCh['chType'] === 'P') {
              redirectChannel = this.chList['private'].find((ch) => ch.chCategory === 'my')
            } else if (this.selectedCh['chType'] === 'W') {
              redirectChannel = this.chList['workspace'].find((ch) => ch.chCategory === 'general')
            }
            await this.$store.dispatch('setSelectedCh', redirectChannel)

            this.$router.replace({
              name: 'Channel',
              params: { wsDomain: this.selectedWsInfo['wsDomain'], chId: redirectChannel['chId'.replace('CH:', '')] },
            })
          }
          // notify(this, 'Success', this.$t('deleteChannelSuccess'), 'success')

          const content = {
            component: Toast,
            props: {
              msg: this.$t('deleteChannelSuccess'),
              // submsg: '',
            },
          }
          this.$toast.success(content)
          await this.$store.dispatch('getChannelList', {
            wsId: this.selectedWsInfo['wsId'],
          })
        } else {
          // notify(this, 'Error', this.$t('deleteChannelFailed'), 'error')

          const content = {
            component: Toast,
            props: {
              msg: this.$t('deleteChannelFailed'),
              // submsg: '',
            },
          }
          this.$toast.error(content)
        }
      } catch (error) {
        console.log(error)
        // notify(this, 'Error', this.$t('deleteChannelFailed'), 'error')

        const content = {
          component: Toast,
          props: {
            msg: this.$t('deleteChannelFailed'),
            // submsg: '',
          },
        }
        this.$toast.error(content)
      } finally {
        this.$store.dispatch('setIsLoading', false)
      }
    },
  },
}
</script>

<style scoped>
.v-list-group >>> .theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
  color: #96a7af !important;
}
.btn-sidebar.active >>> .ch-name,
.btn-sidebar.active >>> .menu-title {
  color: #25c685 !important;
}

.el-dropdown-menu__item:not(.is-disabled):hover {
  background-color: #25c685 !important;
  color: #ffffff !important;
}
.btn-sidebar {
  opacity: 0.9;
  transition: all 0.3s;
  background-color: #1a272e;
  padding-left: 20px !important;
}
.v-list >>> .v-list-item {
  padding-left: 16px;
}
.btn-sidebar:hover,
.btn-sidebar.active {
  background-color: #162127;
  opacity: 1;
}

.theme--light:not(.v-list-item--active) >>> .v-icon {
  color: #96a7af !important;
}

/* .activeColor {
  color: #25c685 !important;
} */

.v-list-item__icon {
  margin: 12px 0 12px 0;
}

.v-list-item {
  min-height: 40px;
}

.v-list-item__title {
  font-size: 13px;
  color: #96a7af;
}
.btn-add-member {
  background: #31434f;
  border: 1px solid #31434f;
  box-sizing: border-box;
  border-radius: 5px;
  width: 190px;
  padding: 10px 0;
  margin: 30px;
  margin-top: 45px;
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  color: #96a7af;
  transition: all 0.3s;
}

.btn-add-member:hover {
  background: #354a59;
  border: 1px solid #374f60;
}

.ws-name {
  width: 200px;
  white-space: nowrap;
  word-break: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 13px;
  font-weight: 600;
  color: #eee;
}

.btn-workspace {
  font-size: 13px;
  font-weight: 500;
  color: #96a7af;
}

.menu-title {
  font-weight: 500;
}

.ch-name >>> * {
  font-size: 14px;
}
.ch-name {
  font-weight: 500;
}

span.ch-name {
  display: block;
  line-height: 20px;
  max-width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ch-name >>> .v-input__prepend-outer {
  display: flex !important;
  align-self: center !important;
  margin: 0 !important;
}
.ch-name >>> .v-input__prepend-outer span {
  font-size: 14px !important;
}
.container-quick {
  position: relative;
}
.container-quick .record {
  opacity: 0;
  position: absolute;
}
.container-quick.isActive .quick-record {
  opacity: 0;
}
.container-quick.isActive .record {
  opacity: 1;
}
.btn-quick {
  position: relative;
  z-index: 2;
  border-radius: 0 15px 15px 0;
  transition: opacity 0s;
}
.btn-quick >>> span {
  color: #ddd;
  margin-right: 25px;
}
.btn-quick.record >>> span {
  margin-right: 65px;
}
.btn-quick-sub >>> span {
  color: #ddd;
  margin-left: 0px;
}
.btn-quick-sub {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 200px;
  background-color: transparent !important;
  border-radius: 0 15px 15px 0;
  position: absolute;
  top: 18px;
  left: 89px;
  transform: translate(-50%, -50%);
  transition: top 0.45s cubic-bezier(0.68, -0.55, 0.265, 1.55), left 0.45s cubic-bezier(0.68, -0.55, 0.265, 1.55),
    background-color 0.5s;
  font-weight: 400;
  font-size: 11px;
  letter-spacing: -0.2px;
  cursor: pointer;
  z-index: 1;
}
.container-quick.isActive .btn-quick-sub {
  transition: top 0.45s cubic-bezier(0.68, -0.55, 0.265, 1.55), left 0.45s cubic-bezier(0.68, -0.55, 0.265, 1.55),
    background-color 0.5s;
}
.container-quick.isActive .text {
  top: -18px;
  left: 90px;
  transition-delay: 0.05s;
  background-color: rgb(49, 67, 79) !important;
  box-shadow: 0 0 0 1px #111a1e;
}
.container-quick.isActive .upload {
  top: -54px;
  left: 90px;
  transition-delay: 0.05s;
  background-color: rgb(49, 67, 79) !important;
  box-shadow: 0 0 0 1px #111a1e;
}
.container-quick.isActive .poll {
  top: -90px;
  left: 90px;
  transition-delay: 0.05s;
  background-color: rgb(49, 67, 79) !important;
  box-shadow: 0 0 0 1px #111a1e;
}
.container-quick.isActive .embed {
  top: -126px;
  left: 90px;
  transition-delay: 0.05s;
  background-color: rgb(49, 67, 79) !important;
  box-shadow: 0 0 0 1px #111a1e;
}
.container-quick.isActive .btn-quick.record:hover {
  background: #e94951 !important;
}
.container-quick.isActive .btn-quick-sub:hover {
  transition: all 0s;
  background: rgb(32, 44, 53) !important;
}
.noti-badge >>> span {
  color: #162127;
  font-weight: 600;
  height: 16px;
  padding: 3px 4px;
  font-size: 11px;
  letter-spacing: -0.5px;
}
.menu-ws >>> .v-list-item__icon {
  margin-right: 15px;
}
</style>
